import { defineComponent as _defineComponent } from 'vue'
import HeaderComponent from "@/components/HeaderComponent.vue";
  import SidebarComponent from "@/components/SidebarComponent.vue";
  import {
    navigation,
    adminNavigation,
    landownerProfileNavigation,
    salesPersonNavigation,
  } from "@/static/navigation";
  import router from "@/router";
  import { UserRoles } from "@/enums/UserRoles";
  import { computed, onMounted, ref } from "vue";
  import store from "../store";
  import { getInitialHoldNavigation } from "@/helpers/initialHold/isInitialHoldDisabled";
  import { LandownerNavigationSlugs } from "@/enums/LandownerNavigationSlugs";
  import isReportsRoute from "@/helpers/analytics/isReportsRoute";
  interface WrapperContentStyles {
    background?: string;
  }
  interface Props {
    wrapperContentStyles?: WrapperContentStyles;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'MainLayout',
  props: {
    wrapperContentStyles: { default: () => ({
      background: "#f5f5f7",
      padding: "30px 20px 20px 24px",
    }) }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const navList = computed(() => {
    const { meta, fullPath } = router.currentRoute.value;
    const { role } = store.state.user.data;
    const isProfilePages = fullPath.startsWith("/landowner/profile");

    if (
      meta?.access &&
      (meta.access as string[]).includes(UserRoles.SUPER_ADMIN)
    ) {
      return adminNavigation;
    }

    if (isProfilePages && role === UserRoles.LANDOWNER) {
      return landownerProfileNavigation;
    }

    if (isProfilePages && role === UserRoles.SALES_PERSON) {
      return salesPersonNavigation;
    }

    const preIndex = navigation.findIndex(
      ({ slug }) => slug === LandownerNavigationSlugs.EOI
    );

    return [
      ...navigation.slice(0, preIndex + 1),
      ...getInitialHoldNavigation(),
      ...navigation.slice(preIndex + 1),
    ];
  });

  const isActiveBurger = ref(false);

  const getEstates = () => {
    return store.dispatch("estate/getEstates", {
      landownerId: store.state.user.data._id,
    });
  };

  onMounted(() => {
    getEstates();
  });

const __returned__ = { props, navList, isActiveBurger, getEstates, HeaderComponent, SidebarComponent, get navigation() { return navigation }, get adminNavigation() { return adminNavigation }, get landownerProfileNavigation() { return landownerProfileNavigation }, get salesPersonNavigation() { return salesPersonNavigation }, get router() { return router }, get UserRoles() { return UserRoles }, computed, onMounted, ref, get store() { return store }, get getInitialHoldNavigation() { return getInitialHoldNavigation }, get LandownerNavigationSlugs() { return LandownerNavigationSlugs }, get isReportsRoute() { return isReportsRoute } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})